import React, { useMemo } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Heading, Modal, Button } from "@reliance/design-system";
import DangerIcon from "../../img/DangerInfo.svg";
import { useTranslation } from "react-i18next";

const TelemedicineAbuseModal = ({ open, onClose, dispensingLimit }) => {
  const { t } = useTranslation("consultations");
  const CONTENT = useMemo(
    () => ({
      modalHeader: t("abuseModalContent.header"),
      belowLimitCount: {
        intro: t("abuseModalContent.belowLimitIntro"),
        notes: [
          t("abuseModalContent.belowLimitFirstBulletNote"),
          t("abuseModalContent.belowLimitSecondBulletNote"),
          t("abuseModalContent.belowLimitThirdBulletNote"),
        ],
        footer: t("abuseModalContent.belowLimitFooter"),
      },
      aboveLimitCount: {
        intro: t("abuseModalContent.aboveLimitIntro"),
        notes: [
          t("abuseModalContent.aboveLimitFirstBulletNote"),
          t("abuseModalContent.aboveLimitSecondBulletNote"),
          t("abuseModalContent.aboveLimitThirdBulletNote"),
        ],
        footer: t("abuseModalContent.aboveLimitFooter"),
      },
    }),
    []
  );

  // const isDispenseBelowLimit = dispensingLimit.limit >= dispensingLimit.count;

  const { intro, notes, footer } =
    dispensingLimit.count < dispensingLimit.limit
      ? CONTENT.belowLimitCount
      : CONTENT.aboveLimitCount;

  return (
    <Modal key="modal" open={open} onOpenChange={onClose}>
      <Modal.Content
        blank
        style={{ fontSize: 16 }}
        className="w-[40vw] lg:w-[38vw] sm:w-auto max-w-[80%]"
      >
        <div className="text-center">
          <div className="flex justify-center items-center h-full">
            <img src={DangerIcon} alt="Info" />
          </div>
          <Heading level="h3" className="m-5" style={{ color: "#1E293B" }}>
            {CONTENT.modalHeader}
          </Heading>
        </div>
        <div className="mb-4">{intro}</div>
        {notes.length > 0 && (
          <ol className="list-disc pl-5 telemedicine-abuse">
            {notes.map((note, index) => (
              <li key={index}>{note}</li>
            ))}
          </ol>
        )}
        <div className="mt-10 mb-12">{footer}</div>
        <Button
          style={{ width: "100%", fontSize: 15, height: 50, margin: "20px 0" }}
          className="border-0 focus:border-0 hover:border-0"
          onClick={onClose}
        >
          {t("telemedicineAbusePrimaryButtonText")}
        </Button>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = ({ consultation }) => ({
  prescriptions: consultation?.prescriptions,
  dispensingLimit: consultation?.active?.dispensingLimit || {},
});

export default withRouter(connect(mapStateToProps)(TelemedicineAbuseModal));
